// Used as vuex store module path
const MODULE_ID = 'fahrdienst';
export default MODULE_ID;
